import React from "react";
import ReactDOM from "react-dom";
import { ConfiguredApp } from "./components";
import * as serviceWorker from "./serviceWorker";
import "./configure-app";
import "./assets/css/App.css";

const render = () => ReactDOM.render(<ConfiguredApp />, document.getElementById("root") || document.createElement('div'));
render();
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
